// extracted by mini-css-extract-plugin
export default {"small_categores_item":"style_small_categores_item__QthaA","mini_ban_img":"style_mini_ban_img__j0pEr"};